module.exports = __webpack_public_path__ + "img/logo-white-posco.c59613d9.svg";